import pictureViewer from "core/templates/story-reading/picture-viewer.hbs";
import {
  openResponsivePopup,
  buildMediaReportUrl
} from "../../../../../components/helpers";
(function(window, wattpad, utils, app, Monaco) {
  "use strict";
  app.add(
    "PictureViewer",
    app.views.Base.extend({
      events: {
        "tap .on-report-image": "onReportImage",
        "tap .on-dismiss": "onDismiss",

        "click .on-dismiss": "stopEvent",
        "click .on-report-image": "stopEvent",

        "tap .vertical-align-helper": "onTapPicture",
        "click .vertical-align-helper": "stopEvent"
      },

      template: pictureViewer,

      id: "picture-viewer",

      initialize: function(options) {
        options = options || {};
        this.contents = "";
        this.mediaLink = "";
        this.mediaLocationId = "";
        // Media type for the report route, supplied by the opening view
        // (inline image vs. header banner); defaults to inline.
        this.reportMediaType = options.reportMediaType || "story_inline_image";

        var imageUrl;

        if (options.contents) {
          this.contents = options.contents;
          this.mediaLink = $(this.contents).attr("src");
          imageUrl = $(options.contents).attr("src");
        }

        if (options.paragraph) {
          // mediaLocationId is the story-part id: prefer the part container the
          // media's paragraph sits in (inline media), else the opening view's
          // part model. The header banner is itself inside a [data-part-id]
          // container, but it's opened without a paragraph ancestor, so the
          // closest() lookup finds nothing and we fall back to partModel.
          this.mediaLocationId =
            $(options.paragraph)
              .closest("[data-part-id]")
              .attr("data-part-id") ||
            (options.partModel && options.partModel.get("id")) ||
            "";
        }

        this.mediaShare = options.mediaShare || [];

        if (this.mediaShare[1]) {
          var pinterestUrl = this.mediaShare[1].href;

          pinterestUrl = this.preparePinterestUrl(imageUrl, pinterestUrl);

          this.mediaShare[1].href = pinterestUrl;
        }

        // The flag's href and its tap handler share one destination, so the
        // markup points at the same webview the popup opens.
        this.reportLink = buildMediaReportUrl({
          mediaUrl: this.mediaLink,
          mediaType: this.reportMediaType,
          mediaLocationType: "storyPart",
          mediaLocationId: this.mediaLocationId
        });

        this.model = options.partModel || {};
      },

      render: function() {
        var device = app.get("device");
        var isTouchDevice = device.isTouchDevice();
        this.$el.html(
          this.template({
            contents: this.contents,
            reportLink: this.reportLink,
            mediaShare: this.mediaShare,
            isTouchDevice: isTouchDevice
          })
        );
        return this;
      },

      onReportImage: function() {
        // Mirrors reportMedia in the parent story-reading view — the opening
        // view supplies a valid mediaLink + mediaLocationId.
        openResponsivePopup({
          url: this.reportLink,
          width: 500,
          height: 700
        });
      },

      onDismiss: function() {
        $("#picture-viewer").one("hidden.bs.modal", function() {
          $(".modal-backdrop").removeClass("black");
        });
        $("#picture-viewer").modal("hide");
      },

      onSharePinterest: function(evt) {
        var targetUrl = $(evt.currentTarget).attr("href");
        window.open(targetUrl);
      },

      onTapPicture: function(evt) {
        utils.stopEvent(evt);
        var device = app.get("device");
        var isTouchDevice = device.isTouchDevice();

        if (isTouchDevice) {
          $(".icon-wrapper").toggleClass("hidden");
        }
      }
    })
  );

  app.mixin(app.views.PictureViewer, "MediaSharing");
})(window, wattpad, wattpad.utils, window.app, window.Monaco);
